import { render, staticRenderFns } from "./FlussiViewPage.vue?vue&type=template&id=7daaa0ee"
import script from "./FlussiViewPage.vue?vue&type=script&lang=js"
export * from "./FlussiViewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports